import cleanserImage from "../../public_html/assets/images/category-cleanse.svg";
import moisturiserImage from "../../public_html/assets/images/category-moisture.svg";
import bodyCareImage from "../../public_html/assets/images/category-body.svg";

export type Region = "uk" | "ireland";
export type ProductAvailability = "coming-soon" | "available" | "unavailable";

export interface ImageRights {
  owner: string;
  licence: string;
  sourceUrl?: string;
  approvedForCommercialUse: boolean;
}

export interface CatalogueImage {
  src: string;
  alt: string;
  rights: ImageRights;
}

export interface BundleComponent {
  supplierSku: string;
  name: string;
  quantity: number;
}

export interface DeliveryEstimate {
  uk: string | null;
  ireland: string | null;
}

export interface Product {
  id: string;
  slug: string;
  name: string;
  brand: string;
  category: string;
  supplierSku: string;
  ukEligible: boolean;
  irelandEligible: boolean;
  retailPricePence: number;
  currency: "GBP";
  bundleComponents: BundleComponent[];
  images: CatalogueImage[];
  description: string;
  ingredients: string[];
  availability: {
    status: ProductAvailability;
    verifiedAt: string | null;
    stockHeldAndVerified: boolean;
  };
  deliveryEstimate: DeliveryEstimate;
}

export interface Category {
  id: string;
  name: string;
  description: string;
  image: string;
  imageAlt: string;
}

export const categories: Category[] = [
  {
    id: "cleansers",
    name: "Cleansers",
    description: "Thoughtful daily essentials, listed with clear product details.",
    image: cleanserImage,
    imageAlt: "Abstract cleanser bottle illustration in warm rose tones"
  },
  {
    id: "moisturisers",
    name: "Moisturisers",
    description: "Comfort-focused formulas with complete details before listing.",
    image: moisturiserImage,
    imageAlt: "Abstract moisturiser jar illustration in soft green and cream"
  },
  {
    id: "body-care",
    name: "Body care",
    description: "Everyday care with clear ingredients and honest descriptions.",
    image: bodyCareImage,
    imageAlt: "Abstract body-care bottle illustration in warm blush tones"
  }
];

// Add products only after every field has been verified.
// The empty array keeps category previews visible without inventing products.
export const products: Product[] = [];

export function isEligibleForRegion(product: Product, region: Region): boolean {
  return region === "uk" ? product.ukEligible : product.irelandEligible;
}

export function isVerifiedInStock(product: Product): boolean {
  return (
    product.availability.status === "available" &&
    product.availability.stockHeldAndVerified &&
    product.availability.verifiedAt !== null
  );
}
